/** Normalize org / option ids so string/number API values match Formik state. */
export const getFilterItemId = (item) => {
  const raw = item?.value?.id ?? item?.key;
  if (raw === undefined || raw === null) return '';
  return String(raw);
};

export const normalizeSelectedId = (id) => {
  if (id === undefined || id === null) return '';
  return String(id);
};

/** Resolve id from a selected filter entry (Formik value or API-shaped object). */
export const getSelectionId = (entry) => {
  if (!entry || typeof entry !== 'object') return '';
  const raw = entry.id ?? entry.organizationId ?? entry.healthOrganizationId;
  if (raw === undefined || raw === null) return '';
  return String(raw);
};
